import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const waitlistSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  search: z.string().catch(''),
  sortBy: z
    .enum([
      'status',
      'email',
      'guestName',
      'checkInCheckOut',
      'nights',
      'adults',
      'children',
      'infant',
    ])
    .catch('status'),
  orderBy: z.enum(['asc', 'desc']).catch('desc'),
})

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/reservations/waitlist/'
)({
  validateSearch: (search) => waitlistSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
  },
  errorComponent: ErrorComponent,
  pendingComponent: LoadingList,
})
